export const API_BASE_URL = (window as any).configs.REACT_APP_AUTH_API_BASE_URL;
export const CLIENTID = (window as any).configs.REACT_APP_CLIENTID;